import { ReactElement } from 'react';

import { PrimaryButton } from '@changegps/horizon-component-library';
import { ButtonProps, CircularProgress, styled } from '@mui/material';

const StyledPrimaryButton = styled((props: ButtonProps) => (
  <PrimaryButton type="submit" {...props} />
))({
  minWidth: 136,
  width: 'fit-content',
  textTransform: 'unset',
});

type SaveButtonProps = Omit<ButtonProps, 'children'> & {
  children?: string;
  isLoading?: boolean;
};

export const SaveButton = ({
  children = 'Save settings',
  isLoading,
  ...props
}: SaveButtonProps): ReactElement => {
  return (
    <StyledPrimaryButton {...props} disabled={props.disabled || isLoading}>
      {isLoading ? <CircularProgress size={18} /> : children}
    </StyledPrimaryButton>
  );
};
